import React from 'react';
import { motion } from 'framer-motion';
export function WhyFailedSection() {
  return <section className="w-full py-24 px-6 md:px-12 lg:px-24 bg-white" data-id="element-253">
      <div className="max-w-3xl mx-auto" data-id="element-254">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="space-y-8 text-lg md:text-xl text-charcoal-light leading-relaxed" data-id="element-255">
          <h2 className="text-3xl md:text-4xl font-serif text-charcoal mb-10 text-center" data-id="element-256">
            Why Everything Else Has Failed
          </h2>

          <p data-id="element-257">You have tried the reward charts.</p>
          <p data-id="element-258">
            You have tried the countdown timers, the visual schedules downloaded
            from Pinterest, the breathing exercises recommended by his
            occupational therapist that work beautifully in the clinic and
            nowhere else.
          </p>
          <p data-id="element-259">
            You have tried staying calm. You have tried being firm. You have
            tried picking your battles until you weren't sure which battles were
            even worth picking anymore.
          </p>

          <p className="font-semibold text-charcoal mt-12" data-id="element-260">
            And here is why none of it has worked consistently:
          </p>

          <div className="bg-amber-light p-8 rounded-2xl my-8" data-id="element-261">
            <p className="text-2xl font-serif text-charcoal text-center" data-id="element-262">
              Every single one of those tools was built for the moment of the
              meltdown.
            </p>
          </div>

          <p data-id="element-263">
            They are reactive. They assume the crisis has already started and
            now you need to manage it.
          </p>
          <p data-id="element-264">
            But a meltdown is not a behavior. It is the end result of a nervous
            system that has been accumulating sensory and emotional overload for
            hours — sometimes days — before the explosion.
          </p>
          <p data-id="element-265">
            By the time your son is on the floor, the window for intervention
            has already closed.
          </p>

          <div className="text-center space-y-6 mt-12" data-id="element-266">
            <p className="text-2xl font-serif text-charcoal" data-id="element-267">
              The only system that works is one that operates before the storm.
              In the yellow zone. Before the point of no return.
            </p>
            <p className="text-xl font-semibold text-amber" data-id="element-268">
              That is exactly what the Crisis Calm Method was built to do.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}